import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { prop } from 'ramda';

import { useAppSelector } from '@core/js/store/hooks';
import { TAG_TYPE_BUZZ } from '@interlayer/js/components/system/TagManager/buzz/constants';
import { useIsShowTag } from '@interlayer/js/components/system/App/buzz/hooks/useIsShowTag';
import { INBOX_CONTAINER } from '@interlayer/js/components/system/CommunicationWidgets/hooks/useInitWidgets/constants.buzz';

export const useManageInboxWidget = () => {
    const isShowTopMenu = useIsShowTag(TAG_TYPE_BUZZ.topNavigation);
    const isDownloadAppOpen = useAppSelector(prop('isDownloadAppOpen'));

    useEffect(() => {
        const updateInboxClassList = () => {
            const inbox = document.getElementById(INBOX_CONTAINER);

            if (!inbox) {
                return;
            }

            inbox.classList[isShowTopMenu ? 'add' : 'remove']('isShowTopMenu');
            inbox.classList[isDownloadAppOpen ? 'add' : 'remove']('isDownloadAppOpen');
        };

        dispatcher.listen('inbox:open', updateInboxClassList);

        return () => {
            dispatcher.removeListener('inbox:open', updateInboxClassList);
        };
    }, [isDownloadAppOpen, isShowTopMenu]);
};
